import { manageMobileMenu } from '@/components/mobileMenu'
import { lazyImages } from '@/components/lazyImages'
import '@/vue/app'

manageMobileMenu()
lazyImages()
